import React, { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectIsHeaderNavDisplayed } from 'cityads-v3/reducers/header';
import { sendEvent } from 'cityads-v3/utils/htmlUtils';
import { RootState } from 'cityads-v3/types/reducer';

import MenuContent from './MenuContent';
import Paper from '@mui/material/Paper';

export default function MenuDesktop() {
  const docked = useSelector((state: RootState) => state.menu.docked);
  const isHeaderDisplayed = useSelector((state: RootState) => state.header.showHeader);
  const isHeaderNavDisplayed = useSelector(selectIsHeaderNavDisplayed);

  const containerRef = useRef(null);
  const onTransitionEnd = useCallback((evt) => {
    if (evt.target === containerRef.current) {
      sendEvent(window, 'resize');
    }
  }, []);

  return (
    <Paper
      square
      ref={containerRef}
      onTransitionEnd={onTransitionEnd}
      sx={[
        {
          position: 'fixed',
          zIndex: '200',
          width: '72px',
          top: '0',
          height: '100vh',
          borderTop: '1px solid rgba(128,128,128,0.2)',
          overflow: 'hidden',
          overflowY: 'auto',
          boxShadow: `rgba(0,0,0,0.05) 3px 0 0,
                    rgba(0,0,0,0.1) 2px 0 0,
                    rgba(0,0,0,0.15) 1px 0 0`,
          transition: 'ease 0.3s width',
        },
        docked && {
          width: '256px',
        },
        isHeaderDisplayed && {
          top: '56px',
          height: 'calc(100vh - 56px)',
        },
        isHeaderNavDisplayed && {
          boxShadow: `rgba(0,0,0,0.05) 3px 49px 0,
                rgba(0,0,0,0.1) 2px 49px 0,
                rgba(0,0,0,0.15) 1px 49px 0`
        }
      ]}
    >
      <MenuContent />
    </Paper>
  );
}
